// Navigation des Moduls `bonus` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul bonus.
import { ChartPieSlice, Coins, Gift } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'bonus',
  title: 'Bonus & equity',
  nav: {
    people: [
      {
        key: 'bonus.rewards',
        label: 'Rewards',
        icon: Coins,
        path: '/bonus',
        roles: ['ALL'],
        order: 50,
        area: 'rail',
        activeFor: ['/contract', '/bonus/equity', '/bonus/letters', '/bonus/adjustments'],
      },
      {
        key: 'bonus.tab',
        label: 'Your bonus',
        icon: Gift,
        path: '/bonus',
        roles: ['ALL'],
        order: 10,
        area: 'tabs:rewards',
      },
    ],
    admin: [
      {
        key: 'bonus.admin',
        label: 'Bonus',
        icon: Gift,
        path: '/rewards/bonus',
        // D4 (SPEC §1.4): ADM hat keinen fachlichen Zugriff auf Boni; HOD arbeitet in der People-App.
        roles: ['PERF', 'COMP', 'CL', 'CEO'],
        order: 310,
        area: 'Rewards',
      },
      {
        key: 'bonus.equity',
        label: 'Equity',
        icon: ChartPieSlice,
        path: '/rewards/equity',
        // D5: COMP schreibt, PERF/CL/CEO lesen.
        roles: ['PERF', 'COMP', 'CL', 'CEO'],
        order: 320,
        area: 'Rewards',
        readOnly: ['PERF', 'CL', 'CEO'],
      },
    ],
  },
});
